/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import useSignUp from './useSignUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserClock } from '@fortawesome/free-solid-svg-icons';
import InputField from '../../../_component/InputField';
import TestimonialSwiper from '../../../_component/TestimonialSwiper';
import { Spin } from 'antd';
import MicrosoftLogin from '../../../_component/MicrosoftLogin';
export default (props) => {
  const {
    loading,
    formInputsError,
    showPassword,
    isAdmin,
    onInputChange,
    onSubmitClick,
    handleShowPassword,
    onForgetPassword,
    onSignInClick,
    checkFieldError,
    onToggleAdmin,
  } = useSignUp(props);

  return (
    <div className="h-screen centered auth-box">
      <div className="auth-box-left centered">
        <div className="auth-left-logo-box">
          <span className="auth-left-logo-icon">
            <FontAwesomeIcon icon={faUserClock} />
          </span>
          <span className="auth-left-logo-text">
            Contact <b>Clues</b>
          </span>
        </div>
        <form className="centered auth-left-form " onSubmit={onSubmitClick}>
          <div className="auth-form-greet">
            <h2 className="auth-form-greet-welcome">Create your account as {isAdmin ? 'Admin' : 'User'} </h2>
          </div>
          {/* <button type="button" className="centered auth-from-login-btn">
            <img src="/assets/images/Google-icon.svg" className="mr-1 w-5 h-5" />
            Sign Up with Google
          </button>
          <div className="centered mb-2 w-full">
            <hr className="h-0 border-b border-solid border-gray-200 grow" />
            <p className="mx-4 text-gray-800">or</p>
            <hr className="h-0 border-b border-solid border-gray-200 grow" />
          </div> */}
          <InputField
            id="fullName"
            placeholder="Full Name"
            onChange={(e) => onInputChange(e.target.value, 'full_name')}
            onBlur={(e) => checkFieldError(e.target.value, 'full_name')}
            error={formInputsError.full_name}
            formSubmitError={formInputsError.formSubmitError}
            containerClassName="containerClass"
            inputClassName="inputClass"
            iconClassName="iconClass"
            errorClassName="errorClass"
            fontIconClassName="fontIconClass"
          />

          <InputField
            id="email"
            placeholder="Email"
            onChange={(e) => onInputChange(e.target.value, 'email')}
            onBlur={(e) => checkFieldError(e.target.value, 'email')}
            error={formInputsError.email}
            formSubmitError={formInputsError.formSubmitError}
            containerClassName="containerClass"
            inputClassName="inputClass"
            iconClassName="iconClass"
            errorClassName="errorClass"
            fontIconClassName="fontIconClass"
          />
          <InputField
            id="password"
            type="password"
            placeholder="Password"
            onChange={(e) => onInputChange(e.target.value, 'password')}
            onBlur={(e) => checkFieldError(e.target.value, 'password')}
            error={formInputsError.password}
            showPassword={showPassword}
            handleShowPassword={handleShowPassword}
            formSubmitError={formInputsError.formSubmitError}
            containerClassName="containerClass"
            inputClassName="inputClass"
            iconClassName="iconClass"
            errorClassName="errorClass"
            fontIconClassName="fontIconClass"
          />
          <div className="auth-form-forgot-remember">
            <label className="auth-form-remember">
              <input type="checkbox" className="remember-checkbox h-4 w-4 text-gray-600" />
              <span className="remember-text">Remember for 30 days</span>
            </label>
            <button type="button" onClick={onForgetPassword} className="auth-form-forgot">
              Forgot Password
            </button>
          </div>
          <button className="auth-form-submit-btn" type="submit" value="Submit">
            {loading ? (
              <div className="w-full centered justify-center">
                <Spin size="small" />
              </div>
            ) : (
              'Sign Up'
            )}
          </button>
          <MicrosoftLogin title="Sign up with Microsoft" />

          {/* <p className="auth-form-account">
            <button type="button" onClick={onToggleAdmin} className="auth-form-account-btn">
              Sign up as {isAdmin ? 'User' : 'Admin'}
            </button>
          </p> */}

          <p className="auth-form-account">
            Already have an account?{' '}
            <button type="button" onClick={onSignInClick} className="auth-form-account-btn">
              Sign in
            </button>
          </p>
        </form>
      </div>

      <div className="auth-box-carousel centered">
        <TestimonialSwiper />
      </div>
    </div>
  );
};
